import { ComponentType } from 'react';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const Form = <P extends object>(component: ComponentType<P>) => styled(component)``;

const Item = <P extends object>(component: ComponentType<P>) => styled(component)`
  &.ant-form-item,
  &.ant-form-item .ant-form-item-label label {
    color: ${palette('foreground', 0)};
  }
  .ant-input-group-addon {
    background: ${palette('background', 57)};
  }
`;

export default Form;
export { Item };
